import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import "./LocalizationItem.scss";

import { openCancelChangeLocaleModal, closeCancelChangeLocaleModal } from '../../../../redux/actions/ui'

import InputCounter from '../../../ui/InputCounter/InputCounter'
import Modal from '../../../ui/Modals/ModalWindow'


const mapStateToProps = state => ({
    loadingChange: state.localizationsList.loadingChange,
    cancelChangeLocaleModal: state.ui.cancelChangeLocaleModal,
});

const mapDispatchToProps = dispatch => ({
    openCancelChangeLocaleModal: () => dispatch(openCancelChangeLocaleModal()),
    closeCancelChangeLocaleModal: () => dispatch(closeCancelChangeLocaleModal()),
})

class LocalizationItem extends Component {
    static propTypes = {
        langKey: PropTypes.string.isRequired,
        langs: PropTypes.array.isRequired,
        langMap: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired,
        onReset: PropTypes.func.isRequired,
        activeUpdatingItem: PropTypes.object,
        loadingChange: PropTypes.bool,
        cancelChangeLocaleModal: PropTypes.object.isRequired,
        openCancelChangeLocaleModal: PropTypes.func.isRequired,
        closeCancelChangeLocaleModal: PropTypes.func.isRequired,
    };

    state = {
        editKeys: {}
    }


    componentDidUpdate(prevProps) {
        if (prevProps.loadingChange && !this.props.loadingChange)
            this.removeEditableKey(prevProps.activeUpdatingItem.id)
    }


    getEditableKeyValue = id => this.state.editKeys[id].value

    getEditableKeyError = id => this.state.editKeys[id]?.error || ''

    getEditableKeyOriginalValue = id => this.state.editKeys[id]?.originalValue

    isEditableKey = id => id in this.state.editKeys

    isChangedKey = id => this.getEditableKeyValue(id) !== this.getEditableKeyOriginalValue(id)

    createEditableKey = (id, value) => this.setState(prevState => ({
        editKeys: { ...prevState.editKeys, [id]: { value, originalValue: value, error: '' } }
    }))

    touchEditableKey = (id, value) => this.setState(prevState => ({
        editKeys: { ...prevState.editKeys, [id]: { ...prevState.editKeys[id], value } }
    }))

    removeEditableKey = id => this.setState(prevState => {
        const { [id]: _, ...rest } = prevState.editKeys
        return { editKeys: rest }
    })


    onResetClick = (id) => {
        if (this.isChangedKey(id)) {
            this.props.onReset(id)
            this.props.openCancelChangeLocaleModal()
        } else {
            this.removeEditableKey(id)
        }
    }

    onSubmitCancel = () => {
        this.removeEditableKey(this.props.activeUpdatingItem.id)
        this.props.closeCancelChangeLocaleModal()
    }

    onSubmitClick = (id) => {
        this.setState(prevState => ({}), () => {this.setState(prevState => ({}))})
        const value = this.getEditableKeyValue(id)
        if (value === '') {
            this.setState(prevState => ({
                editKeys: {
                    ...prevState.editKeys,
                    [id]: { ...prevState.editKeys[id], error: '' }
                }
            }), () => {
                this.setState(prevState => ({
                    editKeys: {
                        ...prevState.editKeys,
                        [id]: { ...prevState.editKeys[id], error: 'Поле не может быть пустым' }
                    }
                }))
            })
        } else {
            if (this.getEditableKeyError(id)) {
                this.setState(prevState => ({
                    editKeys: { ...prevState.editKeys, [id]: { ...prevState.editKeys[id], error: '' } }
                }))
            }

            this.props.onSubmit(id, value)
        }
    }


    renderLocalizationKey = ({ lang, id, value }) => (
      <div key={id} className="localization-card-list__item">
          <span className="localization-card-list__item__lang">
              {this.props.langMap[lang]}
          </span>
          <div
              className="localization-card-list__item__value"
              onClick={() => !this.isEditableKey(id) && this.createEditableKey(id, value)}
          >
              {
                  this.isEditableKey(id)
                      ? <div className="localization-card-list__input-wrapper form-row">
                          <InputCounter
                              value={this.getEditableKeyValue(id)}
                              onChange={(val) => this.touchEditableKey(id, val)}
                              withoutTop={true}
                              error={this.getEditableKeyError(id)}
                          />

                          <div className="localization-card-list__input-wrapper__btns">
                              <button
                                  type="button"
                                  className="btn btn-cs-close"
                                  onClick={() => this.onResetClick(id)}
                              >
                                  <i aria-hidden="true" className="icon">
                                      <svg width="1em" height="1em" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41z"/>
                                      </svg>
                                  </i>
                              </button>
                              <button
                                  type="button"
                                  className="btn btn-green"
                                  onClick={() => this.onSubmitClick(id)}
                              >
                                  <i aria-hidden="true" className="icon">
                                      <svg width="1em" height="1em" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M9.55018 15.15L18.0252 6.675C18.2252 6.475 18.4585 6.375 18.7252 6.375C18.9918 6.375 19.2252 6.475 19.4252 6.675C19.6252 6.875 19.7252 7.11267 19.7252 7.388C19.7252 7.66333 19.6252 7.90067 19.4252 8.1L10.2502 17.3C10.0502 17.5 9.81685 17.6 9.55018 17.6C9.28351 17.6 9.05018 17.5 8.85018 17.3L4.55018 13C4.35018 12.8 4.25418 12.5627 4.26218 12.288C4.27018 12.0133 4.37451 11.7757 4.57518 11.575C4.77585 11.3743 5.01351 11.2743 5.28818 11.275C5.56285 11.2757 5.80018 11.3757 6.00018 11.575L9.55018 15.15Z"/>
                                      </svg>
                                  </i>
                              </button>
                          </div>
                      </div>
                      : value
              }
          </div>

          {
              this.props.cancelChangeLocaleModal.isOpen &&
              this.props.activeUpdatingItem.id === id && <Modal
                  heading="Вы действительно хотите сбросить все внесённые изменения?"
                  confirmText="Сбросить"
                  cancelText="Оставить"
                  modal={this.props.cancelChangeLocaleModal}
                  onSubmit={() => this.onSubmitCancel(id)}
                  onCancel={this.props.closeCancelChangeLocaleModal}
              />
          }
      </div>
    );

    render() {
        return (
            <div className="localization-card">
                <span className="localization-card__key">
                    { this.props.langKey }
                </span>
                <div className="localization-card__list localization-card-list">
                    { this.props.langs.length !== 0 && this.props.langs.map(this.renderLocalizationKey) }
                </div>
            </div>
        );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LocalizationItem);
